export interface FieldErrorProps {
  /** The message, already translated by the app's message layer. Absent draws nothing. */
  readonly children?: string
  /** What the control's `aria-describedby` points at. */
  readonly id?: string
}

/** The one error line under a control. `role="alert"` because it appears after an attempt:
 *  it has to be announced, not merely read on focus. */
export function FieldError({ children, id }: FieldErrorProps) {
  if (children == null || children === '') return null

  return (
    <p id={id} role="alert" className="text-sm font-medium text-destructive">
      {children}
    </p>
  )
}
